export const iconFontAwesomeMoneyDollarSign = (
	<i className="fa-solid fa-dollar-sign"></i>
);
